import { render } from "./VariablePill.vue?vue&type=template&id=0ec1f496&scoped=true"
const script = {}

import "./VariablePill.vue?vue&type=style&index=0&id=0ec1f496&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ec1f496"]])

export default __exports__